import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-detail_step-begin",
  "use": "icon-detail_step-begin-usage",
  "viewBox": "0 0 155 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 155 32\" id=\"icon-detail_step-begin\"><path d=\"M2 0h141.063a2 2 0 011.646.863l9.702 14.043a2 2 0 01-.004 2.278l-9.101 13.098A4 4 0 01142.021 32H2a2 2 0 01-2-2V2a2 2 0 012-2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol